<template>
    <div>
        <template v-for="(n, i) in dureesCount">
            <b-row :key="'row_' + i" class="mb-2">
                <b-col cols="6">
                    <b-form-select
                            :key="'select_' + i"
                            v-model="dureesContrat[i].duree"
                            :state="getFieldState(dureesContrat[i].duree != null)"
                            :disabled="disabled"
                            @change="emit">
                        <template v-slot:first>
                            <b-form-select-option :value="null">
                                Sélectionner une durée de contrat
                            </b-form-select-option>
                        </template>
                        <b-form-select-option v-for="(dureeContratEnum,index) in dureesContratEnum" :key="index"
                                              :value="dureeContratEnum.value"
                                              :disabled="isDisabled(dureeContratEnum.value)">
                            {{dureeContratEnum.text}}
                        </b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col cols="4">
                    <b-form-input
                            v-b-tooltip.hover :title="'Ajouter un nombre d\'effectifs en équivalent temps plein pour chaque type de durée de contrat'"
                            v-model="dureesContrat[i].nbEffectif"
                            type="number"
                            step="any"
                            min="0"
                            @input="emit"
                            :disabled="disabled"
                            placeholder="Nombre d'effectifs"
                            :state="getFieldState(isFilledInput(dureesContrat[i].nbEffectif))">
                    </b-form-input>
                </b-col>
                <b-col cols="1" v-if="n === dureesCount && dureesContrat[i].duree != null && dureesContrat[i].nbEffectif != null"
                       v-b-tooltip.hover.right
                       :title="'Ajouter un nouveau type de durée de contrat'">
                    <Icon icon="plus" size="2x" :key="'add_' + i" @click="addDuree"
                          class="pt-2 typo-grey cursor-pointer"

                    ></Icon>
                </b-col>
                <b-col cols="1" v-if="dureesCount === n && n > 1">
                    <Icon icon="minus" size="2x" :key="'remove_' + i"
                          @click="removeDuree(i)" class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
            </b-row>
        </template>
    </div>

</template>

<script>

  import DureeContratDto from "../../dtos/DureeContratDto";

  export default {
    name: "DureeContratGpec",
    props: ['value', 'dureesContratEnum', 'disabled', 'formSubmitted', 'posteTouched'],
    data() {
      return {
        dureesCount: 1,
        dureesContrat: [new DureeContratDto()]
      }
    },
    watch: {
      value: function (vals) {
        this.initDureesContrat(vals);
      }
    },
    mounted() {
      this.initDureesContrat(this.value);
    },
    methods: {
      initDureesContrat(vals) {
        if (vals && vals.length > 0) {
          this.dureesContrat = vals;
          this.dureesCount = vals.length;
        } else {
          this.dureesContrat = [new DureeContratDto()];
          this.dureesCount = 1;
        }
      },
      getFieldState(fieldState) {
        return this.formSubmitted && this.posteTouched ? fieldState : null;
      },
      isFilledInput(value) {
        return value != null && value !== "";
      },
      emit() {
        this.$emit('input', this.dureesContrat);
      },
      addDuree() {
        this.dureesContrat.push(new DureeContratDto());
        this.dureesCount++;
      },
      removeDuree(index) {
        this.dureesCount--;
        this.dureesContrat.splice(index, 1);
        this.emit();
      },
      isDisabled(dureeContrat) {
        const isAlreadySelected = this.dureesContrat.findIndex(aDureeContrat => aDureeContrat.duree === dureeContrat) !== -1;
        return this.disabled || isAlreadySelected;
      }
    }
  };
</script>
